module.exports = __webpack_public_path__ + "static/img/10.cafd16c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/zh/10.png
// module id = q9AE
// module chunks = 0